"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventsProviderSideEffectsCore = void 0;
const slice_1 = require("../../../containers/MainPageProvider/slice");
exports.eventsProviderSideEffectsCore = {
    topLiveEvents: {
        onSuccess: slice_1.mainPageProviderActions.fetchTopLiveEventsSuccess,
        onError: slice_1.mainPageProviderActions.fetchTopLiveEventsError,
    },
    topLineEvents: {
        onSuccess: slice_1.mainPageProviderActions.fetchTopLineEventsSuccess,
        onError: slice_1.mainPageProviderActions.fetchTopLineEventsError,
    },
    upcomingEvents: {
        onSuccess: slice_1.mainPageProviderActions.fetchUpcomingEventsSuccess,
        onError: slice_1.mainPageProviderActions.fetchUpcomingEventsError,
    },
};
//# sourceMappingURL=index.js.map